module.exports = __webpack_public_path__ + "static/media/belisa_plumilla-webfont.8044a113.woff";